<template>
  <main class="w-full min-h-screen overflow-hidden relative">
    <router-view />
  </main>
</template>
